module.exports = __webpack_public_path__ + "img/banner01.a3b0f5ef.png";